import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai/vanilla";
export const authTokenAtom = atom(null);
export const onboardingCompletedAtom = atomWithStorage("@arc/shared/onboardingCompleted", false, undefined, {
    getOnInit: true,
});
export const referrerAtom = atomWithStorage("@arc/shared/referrer", null, undefined, {
    getOnInit: true,
});
export const isWalletMigrationFinishedAtom = atomWithStorage("@arc/shared/isWalletMigrationFinished", false, undefined, {
    getOnInit: true,
});
//# sourceMappingURL=user.js.map